import React, { useState } from "react";
import SkillHero from "../components/app/skill/SkillHero";
import Impact from "../components/app/skill/Impact";
import { Link } from "react-router-dom";
import Map from "../components/app/skill/Map";
import FindJobLayout from "../components/app/layout/FindJobLayout";
import EarlyAccess from "../components/app/common/EarlyAccess";
import Social, { ISocials } from "../components/app/common/Socials";
import Initiative from "../components/app/skill/Initiative";
import Leaders from "../components/app/skill/Leaders";
import MeetTeam, { ITeamMember } from "../components/app/common/MeetTeam";
import { BlurFade } from "../components/app/BlurFade";
import SkillTestimonials from "../components/app/skill/SkillTestimonial";
import GalleryModal from "../components/app/skill/GalleryModal";

const SkillDevelopmentPage: React.FC = () => {
  const [showGalleryModal, setShowGalleryModal] = useState<boolean>(false);

  const toggleGalleryModal = () => {
    setShowGalleryModal((prev) => !prev);
  };

  const socialImages: string[] = [
    "/learning/socials/social-1.png",
    "/learning/socials/social-2.png",
    "/learning/socials/social-3.png",
    "/learning/socials/social-4.png",
    "/learning/socials/social-5.png",
  ];
  const socialLinks: ISocials[] = [
    {
      url: "/socials/social-facebook.svg",
      name: "Facebook",
      link: "https://www.facebook.com/share/1Biim3dQjF/?mibextid=wwXIfr",
    },
    {
      url: "/socials/social-instagram.svg",
      name: "Instagram",
      link: "https://www.instagram.com/dream_weaversg/",
    },
  ];

  const teamMembers: ITeamMember[] = [
    {
      name: "Pooja Jaglan",
      role: "Sr. Manager (Skills)",
      description: "Jalandhar",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-1.png",
    },
    {
      name: "Daljit Singh",
      role: "State Manager (Skills)",
      description: "Jalandhar",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-2.png",
    },
    {
      name: "Chandan Otreja ",
      role: "Vice-President (School Projects)",
      description: "Jalandhar",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-3.png",
    },
    {
      name: "Sumit Goswami",
      role: "Project Manager",
      description: "Jharkhand",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-4.png",
    },
    {
      name: "Suraj Wade",
      role: "State Coordinator",
      description: "Madhya Pradesh",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-5.png",
    },
    {
      name: "Ashish R Dhar",
      role: "Sr.Operations Manager",
      description: "Bokaro, Jharkhand",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-6.png",
    },
    {
      name: "Shankar",
      role: "Operations Manager",
      description: "Khunti, Jharkhand",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-7.png",
    },
    {
      name: "Pankaj",
      role: "Centre Manager",
      description: "Ranchi, Jharkhand",
      facebook: "/",
      twitter: "/",
      instagram: "/",
      image: "/skill/meet/team-8.png",
    },
  ];
  const leftMember = {
    name: "Anil Khillan",
    role: "Director",
    description: "",
    linkedin: "http://linkedin.com/in/anil-kumar-khillan-09265a26a",
    image: "/skill/meet/anil.png",
  };

  const galleryImages: string[] = [
    "/skill/gallery/gallery-1.png",
    "/skill/gallery/gallery-2.png",
    "/skill/gallery/gallery-3.png",
    "/skill/gallery/gallery-4.png",
    "/skill/gallery/gallery-5.png",
    "/skill/gallery/gallery-6.png",
    "/skill/gallery/gallery-7.png",
    "/skill/gallery/gallery-8.png",
    "/skill/gallery/gallery-9.png",
    "/skill/gallery/gallery-10.png",
  ];
  return (
    <div>
      <section
        className="p-5 sm:p-7 lg:p-10"
        style={{
          backgroundImage: "url(/skill/landing-hero.svg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <BlurFade delay={0.25} inView>
          <SkillHero />
        </BlurFade>
      </section>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 mt-[8rem] md:mt-[13rem] xl:mt-[21.5rem] lg:px-14 xl:px-20">
          <Impact />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="px-5 sm:px-10 lg:px-16 sl:px-20 flex justify-center items-center w-full text-white bg-gradient-to-r from-[#2E2F92] to-[#0E0E2C]">
          <div className="flex flex-col md:flex-row gap-12">
            <div className="flex justify-center">
              <img
                src="/skill/ripple.png"
                alt=""
                className="w-full max-w-[30rem] pl-10"
              />
            </div>
            <div className="flex flex-col flex-1 py-4 md:pt-4">
              <h4 className="font-light text-2xl mb:text-3xl lg:text-5xl">
                A Ripple Effect of Change
              </h4>
              <p className=" lg:pt-5 lg:text-lg font-bold text-[#FFFFFF]">
                Join Us in Building a Skilled India
              </p>
              <h4 className="font-light text-sm pt-2 lg:text-base xl:text-[1.7rem] leading-snug xl:leading-snug flex">
                Whether you're an aspiring learner or a forward-thinking
                organization, Dream Weavers is here to make a difference. Let's
                craft stories of success together!
              </h4>
              <div className="pt-6 flex items-center gap-2 xl:gap-6">
                {/* todo: add link here */}
                <Link to="/">
                  <button className="rounded-full text-sm px-4 py-2 bg-[#00BB68] hover:bg-opacity-90 transition-all duration-200 ease-out font-light xl:w-56 xl:py-3 xl:text-base xl:ml-3">
                    Explore our programs
                  </button>
                </Link>
                <Link to="/" className="underline text-sm font-light">
                  Be Part of the Impact
                </Link>
              </div>
            </div>
          </div>
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-[7.5rem] bg-[#F4F4F4]">
          <Initiative />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28">
          <Leaders />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-10 xl:p-16 bg-[#182152]">
          <Map toggleGalleryModal={toggleGalleryModal} />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16">
          <SkillTestimonials
            title="Don't just take our word for it!"
            smallDecription="See the feedback of our Candidates."
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section>
          {/* todo: add button url here */}
          <FindJobLayout
            title="Boost Your Team's Potential with Expert Corporate Training!"
            description="Looking for tailored training solutions to upskill your workforce? From leadership and domain expertise to soft skills and compliance, Dream Weavers offers industry-leading corporate training programs designed to elevate your organization's performance."
            buttonContent="Get Started Today!"
            buttonUrl="/training"
            underlineUrl="/careers"
          />
        </section>
      </BlurFade>
      <BlurFade delay={0.25} inView>
        <section className="p-5 sm:p-7 lg:p-16 xl:px-28 my-10">
          <MeetTeam
            title="Meet the Skill Leaders at Dream Weavers!"
            description="There are many variations of passages of Lorem Ipsum available, but the majority have suffered in some form, by injected humour"
            teamMembers={teamMembers}
            leftMember={leftMember}
            hideDescription={false}
          />
        </section>
      </BlurFade>
      <section>
        <Social images={socialImages} socialLinks={socialLinks} />
      </section>
      <section
        className="px-5 sm:px-10 mt-10"
        style={{
          backgroundImage: "url('/home/early-access-bg.svg')",
        }}
      >
        <EarlyAccess />
      </section>
      <GalleryModal
        images={galleryImages}
        isOpen={showGalleryModal}
        onClose={toggleGalleryModal}
      />
    </div>
  );
};

export default SkillDevelopmentPage;
